export default {
  data() {
    return {
      modalDepth: 0,
    };
  },
  methods: {
    addEventListeners() {
      // Ensure modalDepth is never negative
      this.modalDepth = Math.max(0, this.modalDepth);

      if (this.modalDepth === 0) {
        history.pushState({ modal: 'open' }, '');
        window.addEventListener('popstate', this.handlePopState);
        document.addEventListener('keydown', this.handleBackspace);
      }
      this.modalDepth++;
      // console.log('Modal depth after adding:', this.modalDepth);
    },
    removeEventListeners() {
      // console.log('Modal depth before removing:', this.modalDepth);
      // Ensure modalDepth is never negative
      this.modalDepth = Math.max(0, this.modalDepth - 1);

      if (this.modalDepth === 0) {
        document.removeEventListener('keydown', this.handleBackspace);
        window.removeEventListener('popstate', this.handlePopState);
      }
      // console.log('Modal depth after removing:', this.modalDepth);
    },
    handleBackspace(event) {
      if (
        event.key === 'Backspace' &&
        !['INPUT', 'TEXTAREA'].includes(event.target.tagName)
      ) {
        event.preventDefault();
        this.cancel();
      }
    },// Remove the 'modal: open' state from history
    handlePopState(event) {
      event.preventDefault();
      this.cancel();
    },
    // The cancel method should be implemented in the component
  },
};